import Swiper from 'swiper/bundle'

export default class CarouselSlider {
	static init(initSlider, options) {
		const slider = document.querySelector(initSlider)

		if (slider) {
			new CarouselSlider(slider, options)
		}
	}
	constructor(slider, options) {
		this.slider = slider

		this.options = { ...options }
		this.container = this.slider.querySelector('.carousel__container')
		this.prevButton = this.slider.querySelector('.carousel__button--prev')
		this.nextButton = this.slider.querySelector('.carousel__button--next')
		this.pagination = this.slider.querySelector('.carousel__pagination')


		this.initSlider()
	}

	initSlider() {
		const opt = {
			slidesPerView: 'auto',
			direction: 'horizontal',
			autoplay: false,
			...(this.nextButton &&
				this.prevButton && {
					navigation: {
						nextEl: this.nextButton,
						prevEl: this.prevButton,
					},
				}),
			...(this.pagination && {
				pagination: {
					el: this.pagination,
					clickable: true,
				},
			}),
		}

		Object.keys(this.options).forEach((key) => {
			if (Object.hasOwnProperty.call(opt, key)) {
				opt[key] = {
					...this.options[key],
					...opt[key],
				}
			} else {
				opt[key] = this.options[key]
			}
		})
       
		new Swiper(this.container, opt)
	}
}
